import axios from 'axios';

const BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const FETCH_EMPLOYEES_REQUEST = 'FETCH_EMPLOYEES_REQUEST';
export const FETCH_EMPLOYEES_SUCCESS = 'FETCH_EMPLOYEES_SUCCESS';
export const FETCH_EMPLOYEES_FAILURE = 'FETCH_EMPLOYEES_FAILURE';

export const fetchEmployees = () => {
  return async (dispatch) => {
    dispatch({ type: FETCH_EMPLOYEES_REQUEST });
    const token = localStorage.getItem('token');

    try {
      const response = await axios.get(`${BASE_URL}/v1/api/getAllEmployee`, {
        headers: { authorization: token },
      });
      dispatch({ type: FETCH_EMPLOYEES_SUCCESS, payload: response.data.data });
    } catch (error) {
      dispatch({
        type: FETCH_EMPLOYEES_FAILURE,
        payload: error.response?.data?.message || error.message,
      });
    }
  };
};
